// Cases à cocher d'options produit : ajoute ou retire, indépendamment du produit
// principal, le produit d'option choisi dans le panier via l'API Ajax de Shopify.
// Volontairement séparé du formulaire "Ajouter au panier" du produit principal
// pour ne pas dépendre du fonctionnement interne (susceptible de changer) du thème.
(function () {
  function cartAdd(variantId) {
    return fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    }).then(function (response) {
      return response.json();
    });
  }

  function cartRemove(variantId) {
    return fetch(Theme.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      // L'API panier de Shopify exige un identifiant texte pour cart/change,
      // contrairement à cart/add qui accepte un nombre.
      body: JSON.stringify({ id: String(variantId), quantity: 0 }),
    }).then(function (response) {
      return response.json();
    });
  }

  function refreshCartUI() {
    var cartItemsComponent = document.querySelector('cart-items-component');
    if (cartItemsComponent && typeof cartItemsComponent.fetchCartData === 'function') {
      cartItemsComponent.fetchCartData();
    }
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('[data-product-addon] .product-options-checkboxes__input');
    if (!checkbox) return;

    var wrapper = checkbox.closest('[data-product-addon]');
    var status = wrapper ? wrapper.querySelector('.product-options-checkboxes__status') : null;
    var variantId = checkbox.dataset.variantId;
    if (!variantId) return;

    var wantsChecked = checkbox.checked;
    checkbox.disabled = true;

    var request = wantsChecked ? cartAdd(variantId) : cartRemove(variantId);

    request
      .then(function (response) {
        if (response && response.status) {
          checkbox.checked = !wantsChecked;
          window.alert(response.message || "Impossible de mettre à jour cette option, réessayez.");
          return;
        }
        if (status) status.hidden = !wantsChecked;
        refreshCartUI();
      })
      .catch(function () {
        checkbox.checked = !wantsChecked;
        window.alert('Erreur de connexion, réessayez.');
      })
      .finally(function () {
        checkbox.disabled = false;
      });
  });
})();
